import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';
import fingoPalette from '@fingo/lib/theme/fingo/palette';
import fingoComponents from '@fingo/lib/theme/fingo/components';
import fingoTypography from '@fingo/lib/theme/fingo/typography';
import fingoBranding from '@fingo/lib/theme/fingo/branding';
import ThemeStrategy from './ThemeStrategy';

class FingoThemeStrategy extends ThemeStrategy {
  constructor() {
    super();
    this.platformCode = REQUESTING_PLATFORM_TO_CODES.FINGO;
    this.palette = fingoPalette;
    this.components = fingoComponents;
    this.typography = fingoTypography;
    this.branding = fingoBranding;
  }

  getPlatformCode() {
    return this.platformCode;
  }

  getPalette() {
    return this.palette;
  }

  getComponents() {
    return this.components;
  }

  getTypography() {
    return this.typography;
  }

  getBranding() {
    return this.branding;
  }
}

export default FingoThemeStrategy;
